module.exports = {
	extends: [
		'/',
		'base',
		'tableSimple',
		'summary',
	],

	config: {
		// translationPrefix: 'events', // overrides model.ninjaModule if given
		tableComponentClass: 'templates_ninja_table_table',
		controllerComponentClass: 'templates_ninja_controller'
	},

	model: {
		ninjaModule: '',
	},

	methods: {
		onBeforeRender(storage){
			if(!this.model.ninjaModule && storage.isClient){
				this.closest('templates_ninja_controller', controller => {
					this.model.ninjaModule = this.config.buttonContext = controller.model.ninjaModule
				}, true)
			}
		},
	},
}